export enum FilePreviewMode {
  grid = 'GRID_VIEW',
  list = 'LIST_VIEW',
}
